import React, { Component } from 'react'
import { Icon } from 'antd'

export default class Detail extends Component<any, any> {
    state = {
        open: false
    }
    toggleVisibility = () => {
        this.setState(prevState => ({ open: !prevState.open }))
    }
    render() {
        const { open } = this.state
        const { families } = this.props

        let title = `נמצאו ${families.length} משפחות`

        return (
            <div style={{ cursor: 'pointer' }}>
                <div style={{ textDecoration: 'underline' }} onClick={() => this.toggleVisibility()}>
                    <Icon type={open ? 'down' : 'left'} style={{ fontSize: '0.8rem', marginLeft: '0.5rem' }} />
                    <span>{title}</span>
                </div>
                <div
                    style={{
                        display: `${this.state.open ? 'flex' : 'none'}`,
                        paddingRight: '1.5rem',
                        flexDirection: 'column'
                    }}
                >
                    <div>
                        {families.map((family, index) => (
                            <div key={index}>
                                <span>{`${index + 1}. ${family.name}`}</span>
                                <br />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }
}
